import isbot from "isbot";
/**
 * Is the current browser a spider / crawler?
 */

function isCrawler() {
  return isbot(navigator.userAgent);
}

export { isCrawler };